import { useMutation } from "@apollo/client"
import { CHANGE_PASSWORD_AUTH_MUTATION } from "@/graphql/queries/changePasswordAuth"

interface ChangePasswordInput {
  userId: number
  passwd: string
}

interface ChangePasswordResponse {
  UserPasswdUpdate: {
    status: {
      success: boolean
      name: string
      detail: string
    }
    user: {
      Person: {
        id: number
        fullName: string
      }
    }
  }
}

interface UseChangePasswordAuthOptions {
  onCompleted?: (data: ChangePasswordResponse) => void
  onError?: (error: any) => void
}

export function useChangePasswordAuth(options: UseChangePasswordAuthOptions = {}) {
  const [changePasswordMutation, { loading, error }] = useMutation<
    ChangePasswordResponse,
    { UserPasswdUpdateInput: ChangePasswordInput }
  >(CHANGE_PASSWORD_AUTH_MUTATION, {
    onCompleted: options.onCompleted,
    onError: options.onError,
  })

  const mutate = (input: ChangePasswordInput) => {
    return changePasswordMutation({
      variables: {
        UserPasswdUpdateInput: input,
      },
    })
  }

  return {
    mutate,
    loading,
    error,
  }
}
